import { Component } from '@angular/core';
import { FooterComponent } from '../../../layout/footer/footer.component';
import { ScrollToTopComponent } from '../../shared/scroll-to-top/scroll-to-top.component';
import { SidebarComponent } from '../../../layout/sidebar/sidebar.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-consultation',
  standalone: true,
  imports: [
    SidebarComponent,
    FooterComponent,
    ScrollToTopComponent,
    RouterOutlet,
  ],
  templateUrl: './consultation.component.html',
  styleUrl: './consultation.component.scss',
})
export class ConsultationComponent {}
